import * as Sentry from "@sentry/tanstackstart-react";
import { createMiddleware } from "@tanstack/react-start";
import { getClientRouterPathname } from "#/modules/util.fetch-client/client-router";
import {
  deriveTenantFromPathname,
  resolveTenantPathnameOnServer,
  runWithTenant,
} from "#/modules/util.fetch-client/tenant-context.server";

/**
 * Global server-function middleware that exposes the current school/schoolyear via tenant headers.
 * Reconstructs tenant from the page URL in both client RPC and SSR/loader phases, then stores it
 * in request-scoped AsyncLocalStorage for the openapi-fetch client to read.
 * Non-school URLs (login, admin, etc.) derive no tenant, so requests are left untouched.
 */
export const tenantContextMiddleware = createMiddleware({ type: "function" })
  .client(async ({ next }) => {
    const tenantPathname = import.meta.env.SSR ? undefined : getClientRouterPathname();
    return next({ sendContext: { tenantPathname } });
  })
  .server(async ({ next, context }) => {
    const pathname = resolveTenantPathnameOnServer(context.tenantPathname);
    const tenant = pathname ? deriveTenantFromPathname(pathname) : {};
    // Same `school.slug` tag as the browser scope (util.instrumentation/sentry.ts), so server-fn
    // transactions and errors filter by school too. Isolation scope = this request only.
    Sentry.getIsolationScope().setTag("school.slug", tenant.school);
    return runWithTenant(tenant, () => next());
  });
